import { arbitrumSepolia, base, ethereum, polygon } from 'thirdweb/chains'
import { createFormattedAddressSet } from './utils'
import { unifyAddress } from 'src/common/utils/web3/unifyAddress'

// Define a set of token addresses that have price feeds
export const TOKENS_WITH_PRICE_FEEDS: Record<number, Set<string>> = {
  [ethereum.id]: createFormattedAddressSet([
    '0x6b175474e89094c44da98b954eedeac495271d0f', // DAI
    '0x1abaea1f7c830bd89acc67ec4af516284b1bc33c', // EUROC
    '0xb17548c7b510427baac4e267bea62e800b247173', // SMT
    '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48', // USDC
    '0xdac17f958d2ee523a2206206994597c13d831ec7', // USDT
    '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599', // wBTC
    '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', // wETH
    '0x6ce43f19a23ba474449d6231446d752ab3db3f6d', // xGold 1 Oz Eth
    '0xba4ac703ca1825a5d32e356c92e9a770feed35b9', // xGold 1 Kg Eth
    '0x7f94388a552580712c4ec724f470c6e4a74b5244', // xGoldBundle Eth
    '0x3505f494c3f0fed0b594e01fa41dd3967645ca39', // SWM
    '0xDA470bB4a09647f844f1d34C35553DfBE6D75b84', // TBONDS01
  ]),
  [polygon.id]: createFormattedAddressSet([
    // '0xa13e07b145cd28294447dd271ea0f158727976be', // AAPL
    // '0x7f72de249ed11d8d33845b8459105caf6ac604a5', // BLK
    // '0x1020d03b5c19d3963484cd8ad8af7e159fd5e261', // COIN
    // '0xe979088ba73977ee0095a30a43f44aec1d45ca0e', // CPNG
    // '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063', // DAI
    // '0x4bcdb11ac9ed682db431ccdddbdb0ea7d6a0f9d2', // INTC
    // '0x7a0c829bc6c06ec71bf0db04e62cdc8863133553', // MSFT
    // '0xe61aa4e693d3ef8ebc8cd901df2fe1f0a6e2ce78', // MSTR
    // '0x0493fa5965963ab9fc587e1dd165c03cc8304226', // NVDA
    // '0xe631dabef60c37a37d70d3b4f812871df663226f', // SMT
    // '0xf4d24f4e0ce54760788b0a0fb352bcc34e7d045f', // TBONDS01
    // '0x60f9971aea32b1b3b369a1fabc435a15c048d0f0', // TBONDS13
    // '0x7fcfa7f21c9390eeb2c0158a892b817bca5fbafb', // TSLA
    '0x3c499c542cef5e3811e1192ce70d8cc03d5c3359', // USDC
    '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', // USDC.e
    // '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6', // wBTC
    // '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619', // wETH
    // '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270', // wMATIC
    // '0xfb75d446e30842c8b7100014db7c5fd2cbfbc072', // xGold 1 Oz Pol
    // '0x973b1894d688f2e45fe9c573ef19a8f519d32208', // xGold 1 Kg Pol
    '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89', // Carbon
  ]),
  [base.id]: createFormattedAddressSet([
    '0x940181a94a35a4569e4529a3cdfb74e38fd98631', // AERO/USD Base
    '0x23ee2343b892b1bb63503a4fabc840e0e2c6810f', // AXL/USD Base
    '0x0555e30da8f98308edb960aa94c0db47230d2b9c', // wBTC/USD Base
    '0x9e1028f5f1d5ede59748ffcee5532509976840e0', // COMP/USD Base
    '0x50c5725949a6f0c72e6c4a641f24049a917db0cb', // DAI/USD Base
    '0x4ed4e862860bed51a9570b96d89af5e1b0efefed', // DEGEN/USD Base
    '0x80e3ee7bab68feaea6e01c44df9daa5de53e4818', // DOGE/USD Base
    '0x4200000000000000000000000000000000000006', // wETH/USD Base
    '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42', // EURC/USD Base
    '0x2da56acb9ea78330f947bd57c54119debda7af71', // MOG/USD Base
    '0x7002458b1df59eccb57387bc79ffc7c29e22e6f7', // OGN/USD Base
    '0xd722e55c1d9d9fa0021a5215cbb904b92b3dc5d4', // RDNT/USD Base
    '0xab36452dbac151be02b16ca17d8919826072f64a', // RSR/USD Base
    '0x22e6966b799c4d5b13be962e1d117b56327fda66', // SNX/USD Base
    '0x9b8df6e244526ab5f6e6400d331db28c8fdddb55', // uSOL/USD Base
    '0xe3b53af74a4bf62ae5511055290838050bf764df', // STG/USD Base
    '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913', // USDC/USD Base
    '0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34', // USDe/USD Base
    '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2', // wUSDT/USD Base
    '0x7f6f6720a73c0f54f95ab343d7efeb1fa991f4f7', // WIF/USD Base
    '0x9eaf8c1e34f05a589eda6bafdf391cf6ad3cb239', // YFI/USD Base
    '0x6985884c4392d348587b19cb9eaaf157f13271cd', // ZRO/USD Base
    '0x084837A03C1c4B16D554eA0DAC2bBA254b97C292', // xGold 1 Oz Pol
    '0xa6760BaD8e60225485DD5d806Ec7D493F5D83003', // xGold 1 Kg Pol
  ]),
  [arbitrumSepolia.id]: createFormattedAddressSet([
    '0x0c39589605DC00922e3762588961DE39eAfA4395', // EUROS (ERC20 initial symbol)
    '0x9b49bff1901021436c8f837336a9f30feda5adf2', // TSLA
    '0x8ced68405bea7f37e6f0ae825f052a466ba198af', // AAPL
    '0xbb8683513744ade7d9c1a050400e61f0055cb843', // TBONDS01
    // '0x3d0c3da469d3f73d51e263acbb04c58d246841ea', // xGold Kg
    '0x862ead81f034bfe80fc8d35b7496ba9d5bf9d044', // xGold Oz
  ]),
}

export const TOKEN_PRICE_MAPPING: Record<string, string> = {
  [unifyAddress('0x2081A1792b15AB1373DcB3B1f181e190F0026446')]: unifyAddress(
    '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89' // CARBON - VICC
  ),
}
